<template>
  <!--begin::details View-->
  <div class="card mb-5 mb-xl-10" id="kt_profile_details_view">
    <!--begin::Card header-->
    <div class="card-header cursor-pointer">
      <!--begin::Card title-->
      <div class="card-title m-0">
        <h3 class="fw-bolder m-0">Please confirm</h3>
      </div>
      <!--end::Card title--> 
    </div>
    <!--begin::Card header-->

    <!--begin::Card body-->
    <div class="card-body p-9">
      <!--begin::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">First Name/Middle Name/Last Name</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.insured_firstName}}/{{formdata.insured_middleName}}/{{formdata.insured_lastName}}</span>
        </div>
        <!--end::Col-->
      </div> 

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Birth Date</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.insured_birthday}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Country of Nationality</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.country_text2}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Job Classification</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.job_classification_text}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Username</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.username}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Sponsor</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.sponsorid}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Upline</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.uplineid}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Position</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.position}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Mobile#</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.insured_mobileNumber}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Email</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.insured_email}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Block Number and Street</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.address_blockAndStreet}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Name of Building(Optional)</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.address_nameOfBuilding}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Unit Number (Optional)</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.address_unitNumber}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">City, Province, Country</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.address_city}}, {{formdata.province_text}}, {{formdata.country_text}} ({{formdata.address_postalCode}})</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->
      
  

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Beneficiary First Name/Middle Name/Last Name</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.beneficiary_firstName}}/{{formdata.beneficiary_middleName}}/{{formdata.beneficiary_lastName}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->
  

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Beneficiary Birth Date</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.beneficiary_birthday}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Beneficiary Contact</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.beneficiary_contact}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row-->

      <!--end::Row-->
      <div class="row mb-7">
        <!--begin::Label-->
        <label class="col-lg-4 fw-bold text-muted">Relationship with Insured</label>
        <!--end::Label-->

        <!--begin::Col-->
        <div class="col-lg-8">
          <span class="fw-bolder fs-6 text-dark">{{formdata.beneficiary_relationship}}</span>
        </div>
        <!--end::Col-->
      </div>
      <!--end::Row--> 

      <!--
      <div class="row mb-7" >
        <div class="d-flex flex-column mb-7 fv-row">
             
            <label class="required fs-6 fw-bold form-label mb-2" >Advisory</label>
            <div class="position-relative">
              
              <p>Please be advised that Stronghold Insurance Company will be conducting a system migration from August 21, 2024 at 12:00 AM, to August 26, 2024 at 11:59PM. During this period, the issuance of Certificates of Insurance (COI) may be affected due to ongoing migration activities.</p>
              <p>For more info please contact our customer care hotline 09176347218.</p>

            </div>
        </div>
      </div>
      -->
 
    

      <div
        class="notice d-flex bg-light-warning rounded border-warning border border-dashed  p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
          <inline-svg src="media/icons/duotone/Code/Warning-1-circle.svg" />
        </span>
        <!--begin::Wrapper-->
        <div class="d-flex flex-stack flex-grow-1 ">
          <!--begin::Content-->
          <div class=" fw-bold">
            <h4 class="text-gray-800 fw-bolder">Network Setup confirmation</h4>

            <div class="fs-6 text-gray-600 ">
              {{formdata.insured_firstName}}, you are requesting to register a new account with  
              <a class="fw-bolder" href="javascript:;"> {{formdata.responsedata.sponsorname}} ({{formdata.sponsorid}})</a> as your Sponsor and you
              will be placed on the   <a class="fw-bolder" href="javascript:;"> {{formdata.position == 'L' ? 'Left' : 'Right'}}  </a> below your upline 
              <a class="fw-bolder" href="javascript:;"> {{formdata.responsedata.uplinename}} ({{formdata.responsedata.actualuplineid}}) </a>
                
                <div class="pt-5" v-if="formdata.uplineid !=  formdata.responsedata.actualuplineid">
                    Your original requested upline is  <a class="fw-bolder" href="javascript:;"> {{formdata.responsedata.requesteduplinename}} ({{formdata.uplineid}}) </a>
                </div>
                <div class="pt-5">
                    Please click Continue to Proceed
                </div>               
            </div>
          </div>
          <!--end::Content-->
        </div>
        <!--end::Wrapper-->
      </div>
    </div>
    <!--end::Card body-->
  </div>
  <!--end::details View-->




</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
 

export default defineComponent({
  name: "account-overview",
  components: { 
  },
    props: { 
        formdata: Object
  },
  setup() {
    onMounted(() => { 
    });
  }
});
</script>
